import script from "./ExchangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExchangeView.vue?vue&type=script&setup=true&lang=js"

import "./ExchangeView.vue?vue&type=style&index=0&id=4e59755e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e59755e"]])

export default __exports__